export const restrictiveAnalysisTokens = {
  colors: {
    brandBlue: "#4b5563",
    brandOrange: "#dd6435",
    brandOrangeHover: "#c85a2f",
    brandOrangeDisabled: "#e6a68d",
    pageBackground: "#F9FAFB",
  },
} as const;
